// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-testing__container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  font-size: 14px;
  color: var(--foreground);
  background-color: var(--background);
  container-type: inline-size;
}
.task-testing__container .spinner {
  color: var(--info-foreground-subtle);
}
.task-testing__container.task-testing__container--empty {
  flex: 1;
  align-items: center;
  justify-content: center;
}
.task-testing__container .task-testing-group {
  flex-shrink: 0;
  margin: 0 12px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  background-color: var(--neutral-background-subtle);
}
.task-testing__container .task-testing-group .task-testing-group__header {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 10px 12px;
  background: none;
  border: none;
  font-size: 14px;
  font-weight: bold;
  color: var(--foreground);
  cursor: pointer;
  outline: none;
}
.task-testing__container .task-testing-group .task-testing-group__header:focus-visible {
  box-shadow: inset 0 0 0 2px var(--ring);
}
.task-testing__container .task-testing-group .task-testing-group__header .task-testing-group__toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: -2px 0;
  border-radius: 4px;
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .task-testing-group .task-testing-group__header .task-testing-group__toggle svg {
  width: 16px;
  height: 16px;
}
.task-testing__container .task-testing-group .task-testing-group__header:hover {
  background-color: var(--neutral-background-medium);
}
.task-testing__container .task-testing-group .task-testing-group__header:hover .task-testing-group__toggle {
  color: var(--foreground);
}
.task-testing__container .task-testing-group .task-testing-group__header .task-testing-group__title {
  text-align: left;
  line-height: 20px;
}
.task-testing__container .task-testing-group .task-testing-group__header .task-testing-group__badge {
  margin-left: auto;
}
.task-testing__container .task-testing-group .task-testing-group__header .task-testing-group__badge--error {
  margin-left: auto;
  display: flex;
  color: var(--danger-foreground-subtle);
}
.task-testing__container .task-testing-group .task-testing-group__content {
  display: flex;
  flex-direction: column;
}
.task-testing__container .task-testing__container--header {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px;
  border-bottom: 1px solid var(--border);
}
.task-testing__container .task-testing__container--header .task-testing__header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.task-testing__container .task-testing__container--header .task-testing__header-actions-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}
.task-testing__container .task-testing__container--body {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
}
.task-testing__container .input {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 12px 0;
  padding: 0 12px;
}
.task-testing__container .input .input__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  width: 100%;
}
.task-testing__container .input [data-slot=alert] {
  margin-top: 6px;
}
.task-testing__container .output {
  flex-shrink: 0;
  padding: 12px;
}
.task-testing__container .output .output__section-empty {
  color: var(--neutral-foreground-subtle);
  font-size: 14px;
  padding: 4px 0;
}
.task-testing__container .output .output__skeleton {
  width: 100%;
  height: 24px;
}
.task-testing__container .output code {
  font-size: 14px;
}
.task-testing__container .error-banner {
  flex-shrink: 0;
  padding: 12px;
}
.task-testing__container .error-banner + .output {
  padding-top: 0;
}
.task-testing__container .run-card {
  --run-card-accent-border: var(--border);
  --run-card-accent-bg: var(--neutral-background-medium);
  --run-card-accent-icon: var(--neutral-foreground-subtle);
  border: 1px solid var(--run-card-accent-border);
  border-radius: 8px;
  overflow: hidden;
  background-color: var(--neutral-background-subtle);
}
.task-testing__container .run-card.run-card--info {
  --run-card-accent-border: var(--info-border-subtle);
  --run-card-accent-bg: var(--info-background-subtle);
  --run-card-accent-icon: var(--info-foreground-subtle);
}
.task-testing__container .run-card.run-card--success {
  --run-card-accent-border: var(--success-border-subtle);
  --run-card-accent-bg: var(--success-background-subtle);
  --run-card-accent-icon: var(--success-foreground-subtle);
}
.task-testing__container .run-card.run-card--error {
  --run-card-accent-border: var(--danger-border-subtle);
  --run-card-accent-bg: var(--danger-background-subtle);
  --run-card-accent-icon: var(--danger-foreground-subtle);
}
.task-testing__container .run-card.run-card--warning {
  --run-card-accent-border: var(--warning-border-subtle);
  --run-card-accent-bg: var(--warning-background-subtle);
  --run-card-accent-icon: var(--warning-foreground-subtle);
}
.task-testing__container .run-card .run-card__title-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
  padding: 6px 12px;
  background-color: var(--run-card-accent-bg);
}
.task-testing__container .run-card .run-card__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  height: 20px;
  color: var(--run-card-accent-icon);
}
.task-testing__container .run-card .run-card__icon svg {
  width: 18px;
  height: 18px;
}
.task-testing__container .run-card .run-card__header-main {
  display: flex;
  flex-direction: column;
  padding: 12px 12px 12px 40px;
}
.task-testing__container .run-card .run-card__header-main > :first-child {
  margin-top: 0;
}
.task-testing__container .run-card .run-card__title-row {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}
.task-testing__container .run-card .run-card__title {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: var(--foreground);
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-testing__container .run-card .run-card__duration {
  margin-left: auto;
  flex-shrink: 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--neutral-foreground-subtle);
  font-variant-numeric: tabular-nums;
}
.task-testing__container .run-card .run-card__meta {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 18px;
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .run-card .run-card__description {
  margin: 4px 0 0;
  font-size: 14px;
  line-height: 19px;
  color: var(--neutral-foreground-subtle);
  overflow-wrap: anywhere;
}
.task-testing__container .run-card .run-card__links {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin-top: 8px;
  max-width: 100%;
}
.task-testing__container .run-card .run-card__links [data-slot=link] {
  max-width: 100%;
  min-width: 0;
}
.task-testing__container .run-card .run-card__links [data-slot=link] .link__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.task-testing__container .run-card .run-card__details {
  margin: 8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.task-testing__container .run-card .run-card__details-row {
  display: flex;
  column-gap: 8px;
  line-height: 18px;
}
.task-testing__container .run-card .run-card__details-label {
  color: var(--neutral-foreground-subtle);
  width: 34%;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-testing__container .run-card .run-card__details-value {
  margin: 0;
  color: var(--foreground);
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
  min-width: 0;
}
@container (max-width: 380px) {
  .task-testing__container .run-card .run-card__details-row {
    flex-wrap: wrap;
  }
  .task-testing__container .run-card .run-card__details-label {
    width: auto;
  }
  .task-testing__container .run-card .run-card__details-value {
    width: 100%;
  }
}
.task-testing__container .run-card .run-card__strips {
  border-top: 1px solid var(--border);
}
.task-testing__container .run-card .run-card__strip + .run-card__strip {
  border-top: 1px solid var(--border);
}
.task-testing__container .run-card .run-card__strip-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .run-card .run-card__strip-header:has(.run-card__strip-toggle:hover) {
  background-color: var(--neutral-background-medium);
  color: var(--foreground);
}
.task-testing__container .run-card .run-card__strip-header:has(.run-card__strip-toggle:hover) .run-card__strip-chevron {
  color: var(--foreground);
}
.task-testing__container .run-card .run-card__strip-header:has(.run-card__strip-toggle:focus-visible) {
  box-shadow: inset 0 0 0 2px var(--ring);
}
.task-testing__container .run-card .run-card__strip-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  padding: 0;
  background: none;
  border: none;
  font-size: 13px;
  color: inherit;
  cursor: pointer;
  text-align: left;
  outline: none;
}
.task-testing__container .run-card .run-card__strip-toggle .run-card__strip-chevron {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin: -2px 0;
  border-radius: 4px;
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .run-card .run-card__strip-toggle .run-card__strip-chevron svg {
  width: 14px;
  height: 14px;
}
.task-testing__container .run-card .run-card__strip-label {
  font-weight: 500;
  color: var(--foreground);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.task-testing__container .run-card .run-card__strip-live {
  flex-shrink: 0;
  color: var(--neutral-foreground-subtle);
  font-size: 12px;
}
.task-testing__container .run-card .run-card__strip-count {
  margin-left: auto;
  flex-shrink: 0;
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .run-card .run-card__strip-count.run-card__strip-count--error {
  color: var(--danger-foreground-subtle);
}
.task-testing__container .run-card .run-card__strip-external {
  margin: -4px 0 -4px auto;
  flex-shrink: 0;
}
.task-testing__container .run-card .run-card__strip-body {
  padding: 8px 12px 12px;
}
.task-testing__container .run-card .run-card__strip-body.run-card__strip-body--full-bleed {
  margin: 0 -1px -1px;
  padding: 0;
  border-top: 1px solid var(--border);
  height: 190px;
  overflow: auto;
  isolation: isolate;
  contain: layout paint;
}
.task-testing__container .run-card .run-card__scope-toggle {
  margin: -4px 0 -4px auto;
  flex-shrink: 0;
}
@container (max-width: 320px) {
  .task-testing__container .run-card .run-card__strip-header {
    flex-wrap: wrap;
  }
  .task-testing__container .run-card .run-card__scope-toggle {
    margin-left: 22px;
  }
}
.task-testing__container .execution-log {
  font-size: 14px;
}
.task-testing__container .execution-log .execution-log__details {
  margin: 4px 0 0 0;
}
.task-testing__container .execution-log .execution-log__details-row {
  display: flex;
  column-gap: 8px;
  line-height: 18px;
}
.task-testing__container .execution-log .execution-log__details-label {
  color: var(--neutral-foreground-subtle);
  white-space: nowrap;
  width: 30%;
  overflow: clip visible;
  text-overflow: ellipsis;
  min-width: 0;
}
.task-testing__container .execution-log .execution-log__details-value {
  color: var(--foreground);
  font-family: var(--font-mono, ui-monospace, monospace);
  width: 70%;
  overflow: clip visible;
  text-overflow: ellipsis;
  min-width: 0;
}
@container (max-width: 380px) {
  .task-testing__container .execution-log .execution-log__details-row {
    flex-wrap: wrap;
  }
  .task-testing__container .execution-log .execution-log__details-label {
    width: auto;
  }
  .task-testing__container .execution-log .execution-log__details-value {
    width: auto;
    overflow: visible;
    white-space: normal;
    word-break: break-word;
  }
}
.task-testing__container .execution-log .execution-log__empty {
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .execution-log .execution-log__empty-action {
  font-weight: bold;
}
.task-testing__container .execution-log .execution-log__entries {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}
.task-testing__container .execution-log .execution-log__entry-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0 0 0 20px;
  margin-bottom: 0;
}
.task-testing__container .execution-log .execution-log__entry-wrapper::before {
  content: "";
  position: absolute;
  left: 6px;
  top: 9px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--border);
  z-index: 1;
}
.task-testing__container .execution-log .execution-log__entry-wrapper::after {
  content: "";
  position: absolute;
  left: 9px;
  top: 20px;
  bottom: -4px;
  width: 1px;
  background-color: var(--border);
}
.task-testing__container .execution-log .execution-log__entry-wrapper:last-child::after {
  display: none;
}
.task-testing__container .execution-log .execution-log__entry-wrapper.execution-log__entry-wrapper--active::before {
  background-color: transparent;
  border: 1px solid var(--input);
}
.task-testing__container .execution-log .execution-log__entry-content {
  padding: 4px 8px;
  border-radius: 4px;
}
.task-testing__container .execution-log .execution-log__entry-content:has(> .execution-log__entry--expandable):hover {
  background-color: var(--neutral-background-medium);
}
.task-testing__container .execution-log .execution-log__entry {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--neutral-foreground-subtle);
  font-size: 14px;
  line-height: 18px;
}
.task-testing__container .execution-log .execution-log__entry--expandable {
  cursor: pointer;
}
.task-testing__container .execution-log .execution-log__entry--expandable:hover {
  color: var(--foreground);
}
.task-testing__container .execution-log .execution-log__toggle {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.task-testing__container .execution-log .execution-log__toggle svg {
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .execution-log .execution-log__labels {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
}
.task-testing__container .execution-log .execution-log__label {
  white-space: nowrap;
  overflow: clip visible;
  text-overflow: ellipsis;
  min-width: 0;
}
.task-testing__container .execution-log .execution-log__label-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.task-testing__container .execution-log .execution-log__duration {
  font-size: 11px;
  color: var(--neutral-foreground-subtle);
  white-space: nowrap;
  flex-shrink: 0;
}
.task-testing__container .execution-log .execution-log__secondary-label {
  color: var(--neutral-foreground-subtle);
  white-space: nowrap;
  overflow: clip visible;
  text-overflow: ellipsis;
  min-width: 0;
  border-radius: 4px;
  background-color: var(--neutral-background-strong);
  padding: 2px 4px;
  font-size: 12px;
  align-self: flex-start;
  margin-top: 2px;
}
.task-testing__container .task-testing-tooltip__trigger {
  display: inline-flex;
  align-items: center;
  width: fit-content;
}
.task-testing__container .code__editor {
  position: relative;
  display: flex;
  flex-direction: column;
}
.task-testing__container .code__editor.code__editor--error .code__editor-codemirror {
  border-color: var(--danger-foreground-subtle);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--danger-foreground-subtle) 20%, transparent);
}
.task-testing__container .code__editor .code__editor-codemirror {
  border: 1px solid var(--input);
  border-radius: 0.5rem;
  background-color: var(--input-background);
}
.task-testing__container .code__editor .code__editor-codemirror .cm-scroller {
  overflow: visible !important;
}
.task-testing__container .code__editor .code__editor-codemirror .cm-gutters {
  border-right-color: var(--border);
  border-top-left-radius: calc(0.5rem - 1px);
  border-bottom-left-radius: calc(0.5rem - 1px);
  background-color: transparent;
  color: var(--neutral-foreground-subtle);
}
.task-testing__container .code__editor .code__editor-codemirror .cm-content {
  padding: 6px;
}
.task-testing__container .code__editor .code__editor-codemirror .cm-focused {
  outline: none;
}
.task-testing__container .code__editor .code__editor-codemirror .cm-tooltip {
  font-size: 14px;
}
.task-testing__container .code__editor .code__editor-codemirror .info {
  padding: 6px;
  font-family: var(--font-mono, ui-monospace, monospace);
  font-size: 12px;
  max-width: 300px;
  word-wrap: break-word;
}
.task-testing__container .code__editor .code__editor-codemirror .info pre {
  margin-top: 8px;
}
.task-testing__container .code__editor .code__editor-error {
  color: var(--danger-foreground-subtle);
  font-size: 14px;
  margin-top: 6px;
}
.task-testing__container .code__editor .code__editor-buttons {
  position: absolute;
  top: 1px;
  right: 1px;
  z-index: 10;
}
.task-testing__container .has-tooltip {
  border-bottom: 1px dotted currentColor;
  cursor: help;
}

.task-testing-tooltip {
  --tooltip-color-link: var(--color-sky-300);
  max-width: 300px;
}
.task-testing-tooltip a {
  color: var(--tooltip-color-link);
  text-decoration: underline;
}
.task-testing-tooltip code, .task-testing-tooltip pre {
  font-family: var(--font-mono, ui-monospace, monospace);
  padding: 0 2px;
  background-color: color-mix(in srgb, var(--background) 15%, transparent);
  border-radius: 2px;
}
.task-testing-tooltip .bio-properties-panel-tooltip-content h1 {
  font-size: inherit;
  font-weight: bold;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./lib/style/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,wBAAA;EACA,mCAAA;EACA,2BAAA;AACF;AACE;EACE,oCAAA;AACJ;AAEE;EACE,OAAA;EACA,mBAAA;EACA,uBAAA;AAAJ;AAIE;EACE,cAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AAFJ;AAII;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;AAFN;AAKM;EACE,uCAAA;AAHR;AAMM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,uCAAA;AAJR;AAMQ;EACE,WAAA;EACA,YAAA;AAJV;AAQM;EACE,kDAAA;AANR;AASM;EACE,wBAAA;AAPR;AAUM;EACE,gBAAA;EACA,iBAAA;AARR;AAWM;EACE,iBAAA;AATR;AAYM;EACE,iBAAA;EACA,aAAA;EACA,sCAAA;AAVR;AAcI;EACE,aAAA;EACA,sBAAA;AAZN;AAgBE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,sCAAA;AAdJ;AAgBI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAdN;AAiBI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAfN;AAmBE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AAlBJ;AAoBI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAlBN;AAsBI;EACE,eAAA;AApBN;AAwBE;EACE,cAAA;EACA,aAAA;AAtBJ;AAwBI;EACE,uCAAA;EACA,eAAA;EACA,cAAA;AAtBN;AAyBI;EACE,WAAA;EACA,YAAA;AAvBN;AA0BI;EACE,eAAA;AAxBN;AA4BE;EACE,cAAA;EACA,aAAA;AA1BJ;AA8BE;EACE,cAAA;AA5BJ;AAiCE;EACE,uCAAA;EACA,sDAAA;EACA,wDAAA;EAEA,+CAAA;EACA,kBAAA;EACA,gBAAA;EACA,kDAAA;AAhCJ;AAkCI;EACE,mDAAA;EACA,mDAAA;EACA,qDAAA;AAhCN;AAmCI;EACE,sDAAA;EACA,sDAAA;EACA,wDAAA;AAjCN;AAoCI;EACE,qDAAA;EACA,qDAAA;EACA,uDAAA;AAlCN;AAqCI;EACE,sDAAA;EACA,sDAAA;EACA,wDAAA;AAnCN;AAsCI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;AApCN;AAuCI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kCAAA;AArCN;AAuCM;EACE,WAAA;EACA,YAAA;AArCR;AA0CI;EACE,aAAA;EACA,sBAAA;EACA,4BAAA;AAxCN;AA0CM;EACE,aAAA;AAxCR;AA4CI;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA1CN;AA6CI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AA3CN;AA8CI;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,kCAAA;AA5CN;AA+CI;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;AA7CN;AAgDI;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,uCAAA;EACA,uBAAA;AA9CN;AAiDI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;AA/CN;AAiDM;EACE,eAAA;EACA,YAAA;AA/CR;AAiDQ;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA/CV;AAoDI;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAlDN;AAqDI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AAnDN;AAsDI;EACE,uCAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AApDN;AAuDI;EACE,SAAA;EACA,wBAAA;EACA,sDAAA;EACA,eAAA;EACA,qBAAA;EACA,sBAAA;EACA,YAAA;AArDN;AAwDI;EACE;IACE,eAAA;EAtDN;EAyDI;IACE,WAAA;EAvDN;EA0DI;IACE,WAAA;EAxDN;AACF;AA2DI;EACE,mCAAA;AAzDN;AA4DI;EACE,mCAAA;AA1DN;AA6DI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,uCAAA;AA3DN;AA8DM;EACE,kDAAA;EACA,wBAAA;AA5DR;AA+DM;EACE,wBAAA;AA7DR;AAiEM;EACE,uCAAA;AA/DR;AAmEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AAjEN;AAmEM;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,uCAAA;AAjER;AAmEQ;EACE,WAAA;EACA,YAAA;AAjEV;AAsEI;EACE,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AApEN;AAuEI;EACE,cAAA;EACA,uCAAA;EACA,eAAA;AArEN;AAwEI;EACE,iBAAA;EACA,cAAA;EACA,uCAAA;AAtEN;AAwEM;EACE,sCAAA;AAtER;AA0EI;EACE,wBAAA;EACA,cAAA;AAxEN;AA2EI;EACE,sBAAA;AAzEN;AA2EM;EACE,mBAAA;EACA,UAAA;EACA,mCAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AAzER;AA8EI;EACE,wBAAA;EACA,cAAA;AA5EN;AA+EI;EACE;IACE,eAAA;EA7EN;EAgFI;IACE,iBAAA;EA9EN;AACF;AAkFE;EACE,eAAA;AAhFJ;AAkFI;EACE,iBAAA;AAhFN;AAmFI;EACE,aAAA;EACA,eAAA;EACA,iBAAA;AAjFN;AAoFI;EACE,uCAAA;EACA,mBAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAlFN;AAqFI;EACE,wBAAA;EACA,sDAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAnFN;AAsFI;EACE;IACE,eAAA;EApFN;EAuFI;IACE,WAAA;EArFN;EAwFI;IACE,WAAA;IACA,iBAAA;IACA,mBAAA;IACA,sBAAA;EAtFN;AACF;AAyFI;EACE,uCAAA;AAvFN;AA0FI;EACE,iBAAA;AAxFN;AA2FI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAzFN;AA4FI;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AA1FN;AA6FM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,UAAA;AA3FR;AA+FM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,+BAAA;AA7FR;AAgGM;EACE,aAAA;AA9FR;AAiGM;EAEE,6BAAA;EACA,8BAAA;AAhGR;AAoGI;EACE,gBAAA;EACA,kBAAA;AAlGN;AAoGM;EACE,kDAAA;AAlGR;AAsGI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uCAAA;EACA,eAAA;EACA,iBAAA;AApGN;AAuGI;EACE,eAAA;AArGN;AAuGM;EACE,wBAAA;AArGR;AAyGI;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAvGN;AAyGM;EACE,uCAAA;AAvGR;AA2GI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;AAzGN;AA4GI;EACE,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AA1GN;AA6GI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AA3GN;AA8GI;EACE,eAAA;EACA,uCAAA;EACA,mBAAA;EACA,cAAA;AA5GN;AA+GI;EACE,uCAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,kDAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;AA7GN;AAiHE;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;AA/GJ;AAkHE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;AAhHJ;AAmHI;EACE,6CAAA;EACA,0FAAA;AAjHN;AAoHI;EACE,8BAAA;EACA,qBAAA;EACA,yCAAA;AAlHN;AAoHM;EACE,4BAAA;AAlHR;AAqHM;EACE,iCAAA;EACA,0CAAA;EACA,6CAAA;EACA,6BAAA;EACA,uCAAA;AAnHR;AAsHM;EACE,YAAA;AApHR;AAuHM;EACE,aAAA;AArHR;AAwHM;EACE,eAAA;AAtHR;AAyHM;EACE,YAAA;EACA,sDAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAvHR;AAyHQ;EACE,eAAA;AAvHV;AA4HI;EACE,sCAAA;EACA,eAAA;EACA,eAAA;AA1HN;AA6HI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;AA3HN;AAgIE;EACE,sCAAA;EACA,YAAA;AA9HJ;;AAmIA;EAGE,0CAAA;EAEA,gBAAA;AAnIF;AAqIE;EACE,gCAAA;EACA,0BAAA;AAnIJ;AAsIE;EACE,sDAAA;EACA,cAAA;EACA,wEAAA;EACA,kBAAA;AApIJ;AAuIE;EACE,kBAAA;EACA,iBAAA;EACA,SAAA;AArIJ","sourcesContent":[".task-testing__container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  font-size: 14px;\n  color: var(--foreground);\n  background-color: var(--background);\n  container-type: inline-size;\n\n  .spinner {\n    color: var(--info-foreground-subtle);\n  }\n\n  &.task-testing__container--empty {\n    flex: 1;\n    align-items: center;\n    justify-content: center;\n  }\n\n  // a card like the run card above it, so the two sections read as siblings\n  .task-testing-group {\n    flex-shrink: 0;\n    margin: 0 12px 12px;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    overflow: hidden;\n    background-color: var(--neutral-background-subtle);\n\n    .task-testing-group__header {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      width: 100%;\n      height: 40px;\n      box-sizing: border-box;\n      padding: 10px 12px;\n      background: none;\n      border: none;\n      font-size: 14px;\n      font-weight: bold;\n      color: var(--foreground);\n      cursor: pointer;\n      outline: none;\n\n      // the design system's focus ring, inset like its Card title\n      &:focus-visible {\n        box-shadow: inset 0 0 0 2px var(--ring);\n      }\n\n      .task-testing-group__toggle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        margin: -2px 0;\n        border-radius: 4px;\n        color: var(--neutral-foreground-subtle);\n\n        svg {\n          width: 16px;\n          height: 16px;\n        }\n      }\n\n      &:hover {\n        background-color: var(--neutral-background-medium);\n      }\n\n      &:hover .task-testing-group__toggle {\n        color: var(--foreground);\n      }\n\n      .task-testing-group__title {\n        text-align: left;\n        line-height: 20px;\n      }\n\n      .task-testing-group__badge {\n        margin-left: auto;\n      }\n\n      .task-testing-group__badge--error {\n        margin-left: auto;\n        display: flex;\n        color: var(--danger-foreground-subtle);\n      }\n    }\n\n    .task-testing-group__content {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n\n  .task-testing__container--header {\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    width: 100%;\n    padding: 12px;\n    border-bottom: 1px solid var(--border);\n\n    .task-testing__header-actions {\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n    }\n\n    .task-testing__header-actions-right {\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n    }\n  }\n\n  .task-testing__container--body {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    min-height: 0;\n    overflow-y: auto;\n  }\n\n  .input {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin: 12px 0;\n    padding: 0 12px;\n\n    .input__header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 6px;\n      width: 100%;\n    }\n\n    // the hint is a block of its own, not part of the label + editor field\n    [data-slot=\"alert\"] {\n      margin-top: 6px;\n    }\n  }\n\n  .output {\n    flex-shrink: 0;\n    padding: 12px;\n\n    .output__section-empty {\n      color: var(--neutral-foreground-subtle);\n      font-size: 14px;\n      padding: 4px 0;\n    }\n\n    .output__skeleton {\n      width: 100%;\n      height: 24px;\n    }\n\n    code {\n      font-size: 14px;\n    }\n  }\n\n  .error-banner {\n    flex-shrink: 0;\n    padding: 12px;\n  }\n\n  // error banner could be above the last result, keep a single gap between the two\n  .error-banner + .output {\n    padding-top: 0;\n  }\n\n  // raised surface like the design system's Card; the status fill (the DS\n  // Alert's) covers only the title bar, so long incident details stay neutral\n  .run-card {\n    --run-card-accent-border: var(--border);\n    --run-card-accent-bg: var(--neutral-background-medium);\n    --run-card-accent-icon: var(--neutral-foreground-subtle);\n\n    border: 1px solid var(--run-card-accent-border);\n    border-radius: 8px;\n    overflow: hidden;\n    background-color: var(--neutral-background-subtle);\n\n    &.run-card--info {\n      --run-card-accent-border: var(--info-border-subtle);\n      --run-card-accent-bg: var(--info-background-subtle);\n      --run-card-accent-icon: var(--info-foreground-subtle);\n    }\n\n    &.run-card--success {\n      --run-card-accent-border: var(--success-border-subtle);\n      --run-card-accent-bg: var(--success-background-subtle);\n      --run-card-accent-icon: var(--success-foreground-subtle);\n    }\n\n    &.run-card--error {\n      --run-card-accent-border: var(--danger-border-subtle);\n      --run-card-accent-bg: var(--danger-background-subtle);\n      --run-card-accent-icon: var(--danger-foreground-subtle);\n    }\n\n    &.run-card--warning {\n      --run-card-accent-border: var(--warning-border-subtle);\n      --run-card-accent-bg: var(--warning-background-subtle);\n      --run-card-accent-icon: var(--warning-foreground-subtle);\n    }\n\n    .run-card__title-bar {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      min-height: 40px;\n      padding: 6px 12px;\n      background-color: var(--run-card-accent-bg);\n    }\n\n    .run-card__icon {\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      height: 20px;\n      color: var(--run-card-accent-icon);\n\n      svg {\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    // indented to align with the title, past the icon\n    .run-card__header-main {\n      display: flex;\n      flex-direction: column;\n      padding: 12px 12px 12px 40px;\n\n      > :first-child {\n        margin-top: 0;\n      }\n    }\n\n    .run-card__title-row {\n      flex: 1;\n      min-width: 0;\n      display: flex;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .run-card__title {\n      font-size: 14px;\n      font-weight: 700;\n      line-height: 20px;\n      color: var(--foreground);\n      min-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .run-card__duration {\n      margin-left: auto;\n      flex-shrink: 0;\n      font-size: 13px;\n      line-height: 20px;\n      color: var(--neutral-foreground-subtle);\n      font-variant-numeric: tabular-nums;\n    }\n\n    .run-card__meta {\n      margin: 4px 0 0;\n      font-size: 13px;\n      line-height: 18px;\n      color: var(--neutral-foreground-subtle);\n    }\n\n    .run-card__description {\n      margin: 4px 0 0;\n      font-size: 14px;\n      line-height: 19px;\n      color: var(--neutral-foreground-subtle);\n      overflow-wrap: anywhere;\n    }\n\n    .run-card__links {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      gap: 4px;\n      margin-top: 8px;\n      max-width: 100%;\n\n      [data-slot=\"link\"] {\n        max-width: 100%;\n        min-width: 0;\n\n        .link__text {\n          min-width: 0;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          white-space: nowrap;\n        }\n      }\n    }\n\n    .run-card__details {\n      margin: 8px 0 0;\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n    }\n\n    .run-card__details-row {\n      display: flex;\n      column-gap: 8px;\n      line-height: 18px;\n    }\n\n    .run-card__details-label {\n      color: var(--neutral-foreground-subtle);\n      width: 34%;\n      flex-shrink: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .run-card__details-value {\n      margin: 0;\n      color: var(--foreground);\n      font-family: var(--font-mono, ui-monospace, monospace);\n      font-size: 13px;\n      white-space: pre-wrap;\n      word-break: break-word;\n      min-width: 0;\n    }\n\n    @container (max-width: 380px) {\n      .run-card__details-row {\n        flex-wrap: wrap;\n      }\n\n      .run-card__details-label {\n        width: auto;\n      }\n\n      .run-card__details-value {\n        width: 100%;\n      }\n    }\n\n    .run-card__strips {\n      border-top: 1px solid var(--border);\n    }\n\n    .run-card__strip + .run-card__strip {\n      border-top: 1px solid var(--border);\n    }\n\n    .run-card__strip-header {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 8px 12px;\n      font-size: 13px;\n      color: var(--neutral-foreground-subtle);\n\n      // the whole row reacts, but not while another control in it is hovered\n      &:has(.run-card__strip-toggle:hover) {\n        background-color: var(--neutral-background-medium);\n        color: var(--foreground);\n      }\n\n      &:has(.run-card__strip-toggle:hover) .run-card__strip-chevron {\n        color: var(--foreground);\n      }\n\n      // the design system's focus ring, drawn on the row the toggle spans\n      &:has(.run-card__strip-toggle:focus-visible) {\n        box-shadow: inset 0 0 0 2px var(--ring);\n      }\n    }\n\n    .run-card__strip-toggle {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      flex: 1;\n      min-width: 0;\n      padding: 0;\n      background: none;\n      border: none;\n      font-size: 13px;\n      color: inherit;\n      cursor: pointer;\n      text-align: left;\n      outline: none;\n\n      .run-card__strip-chevron {\n        flex-shrink: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        margin: -2px 0;\n        border-radius: 4px;\n        color: var(--neutral-foreground-subtle);\n\n        svg {\n          width: 14px;\n          height: 14px;\n        }\n      }\n    }\n\n    .run-card__strip-label {\n      font-weight: 500;\n      color: var(--foreground);\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n\n    .run-card__strip-live {\n      flex-shrink: 0;\n      color: var(--neutral-foreground-subtle);\n      font-size: 12px;\n    }\n\n    .run-card__strip-count {\n      margin-left: auto;\n      flex-shrink: 0;\n      color: var(--neutral-foreground-subtle);\n\n      &.run-card__strip-count--error {\n        color: var(--danger-foreground-subtle);\n      }\n    }\n\n    .run-card__strip-external {\n      margin: -4px 0 -4px auto;\n      flex-shrink: 0;\n    }\n\n    .run-card__strip-body {\n      padding: 8px 12px 12px;\n\n      &.run-card__strip-body--full-bleed {\n        margin: 0 -1px -1px;\n        padding: 0;\n        border-top: 1px solid var(--border);\n        height: 190px;\n        overflow: auto;\n        isolation: isolate;\n        contain: layout paint;\n      }\n    }\n\n    // the 24px toggle overlaps the row padding, so this row keeps the height of the other strips\n    .run-card__scope-toggle {\n      margin: -4px 0 -4px auto;\n      flex-shrink: 0;\n    }\n\n    @container (max-width: 320px) {\n      .run-card__strip-header {\n        flex-wrap: wrap;\n      }\n\n      .run-card__scope-toggle {\n        margin-left: 22px;\n      }\n    }\n  }\n\n  .execution-log {\n    font-size: 14px;\n\n    .execution-log__details {\n      margin: 4px 0 0 0;\n    }\n\n    .execution-log__details-row {\n      display: flex;\n      column-gap: 8px;\n      line-height: 18px;\n    }\n\n    .execution-log__details-label {\n      color: var(--neutral-foreground-subtle);\n      white-space: nowrap;\n      width: 30%;\n      overflow: clip visible;\n      text-overflow: ellipsis;\n      min-width: 0;\n    }\n\n    .execution-log__details-value {\n      color: var(--foreground);\n      font-family: var(--font-mono, ui-monospace, monospace);\n      width: 70%;\n      overflow: clip visible;\n      text-overflow: ellipsis;\n      min-width: 0;\n    }\n\n    @container (max-width: 380px) {\n      .execution-log__details-row {\n        flex-wrap: wrap;\n      }\n\n      .execution-log__details-label {\n        width: auto;\n      }\n\n      .execution-log__details-value {\n        width: auto;\n        overflow: visible;\n        white-space: normal;\n        word-break: break-word;\n      }\n    }\n\n    .execution-log__empty {\n      color: var(--neutral-foreground-subtle);\n    }\n\n    .execution-log__empty-action {\n      font-weight: bold;\n    }\n\n    .execution-log__entries {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      position: relative;\n    }\n\n    .execution-log__entry-wrapper {\n      display: flex;\n      flex-direction: column;\n      position: relative;\n      padding: 0 0 0 20px;\n      margin-bottom: 0;\n\n      // timeline dot, centered under the strip chevrons\n      &::before {\n        content: '';\n        position: absolute;\n        left: 6px;\n        top: 9px;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        background-color: var(--border);\n        z-index: 1;\n      }\n\n      // timeline line\n      &::after {\n        content: '';\n        position: absolute;\n        left: 9px;\n        top: 20px;\n        bottom: -4px;\n        width: 1px;\n        background-color: var(--border);\n      }\n\n      &:last-child::after {\n        display: none;\n      }\n\n      &.execution-log__entry-wrapper--active::before {\n        // make it unfilled with a border to indicate active entry\n        background-color: transparent;\n        border: 1px solid var(--input);\n      }\n    }\n\n    .execution-log__entry-content {\n      padding: 4px 8px;\n      border-radius: 4px;\n\n      &:has(> .execution-log__entry--expandable):hover {\n        background-color: var(--neutral-background-medium);\n      }\n    }\n\n    .execution-log__entry {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      color: var(--neutral-foreground-subtle);\n      font-size: 14px;\n      line-height: 18px;\n    }\n\n    .execution-log__entry--expandable {\n      cursor: pointer;\n\n      &:hover {\n        color: var(--foreground);\n      }\n    }\n\n    .execution-log__toggle {\n      display: flex;\n      align-items: center;\n      margin-left: auto;\n\n      svg {\n        color: var(--neutral-foreground-subtle);\n      }\n    }\n\n    .execution-log__labels {\n      display: flex;\n      flex-direction: column;\n      min-width: 0;\n      flex: 1;\n    }\n\n    .execution-log__label {\n      white-space: nowrap;\n      overflow: clip visible;\n      text-overflow: ellipsis;\n      min-width: 0;\n    }\n\n    .execution-log__label-row {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      min-width: 0;\n    }\n\n    .execution-log__duration {\n      font-size: 11px;\n      color: var(--neutral-foreground-subtle);\n      white-space: nowrap;\n      flex-shrink: 0;\n    }\n\n    .execution-log__secondary-label {\n      color: var(--neutral-foreground-subtle);\n      white-space: nowrap;\n      overflow: clip visible;\n      text-overflow: ellipsis;\n      min-width: 0;\n      border-radius: 4px;\n      background-color: var(--neutral-background-strong);\n      padding: 2px 4px;\n      font-size: 12px;\n      align-self: flex-start;\n      margin-top: 2px;\n    }\n  }\n\n  .task-testing-tooltip__trigger {\n    display: inline-flex;\n    align-items: center;\n    width: fit-content;\n  }\n\n  .code__editor {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n\n    // matches the design system's invalid Input\n    &.code__editor--error .code__editor-codemirror {\n      border-color: var(--danger-foreground-subtle);\n      box-shadow: 0 0 0 3px color-mix(in srgb, var(--danger-foreground-subtle) 20%, transparent);\n    }\n\n    .code__editor-codemirror {\n      border: 1px solid var(--input);\n      border-radius: 0.5rem;\n      background-color: var(--input-background);\n\n      .cm-scroller {\n        overflow: visible !important;\n      }\n\n      .cm-gutters {\n        border-right-color: var(--border);\n        border-top-left-radius: calc(0.5rem - 1px);\n        border-bottom-left-radius: calc(0.5rem - 1px);\n        background-color: transparent;\n        color: var(--neutral-foreground-subtle);\n      }\n\n      .cm-content {\n        padding: 6px;\n      }\n\n      .cm-focused {\n        outline: none;\n      }\n\n      .cm-tooltip {\n        font-size: 14px;\n      }\n\n      .info {\n        padding: 6px;\n        font-family: var(--font-mono, ui-monospace, monospace);\n        font-size: 12px;\n        max-width: 300px;\n        word-wrap: break-word;\n\n        pre {\n          margin-top: 8px;\n        }\n      }\n    }\n\n    .code__editor-error {\n      color: var(--danger-foreground-subtle);\n      font-size: 14px;\n      margin-top: 6px;\n    }\n\n    .code__editor-buttons {\n      position: absolute;\n      top: 1px;\n      right: 1px;\n      z-index: 10;\n    }\n  }\n\n  // a term that explains itself on hover, drawn like the design system's DefinitionTooltip trigger\n  .has-tooltip {\n    border-bottom: 1px dotted currentColor;\n    cursor: help;\n  }\n}\n\n// Rich content inside the design system's Tooltip (portaled to document.body)\n.task-testing-tooltip {\n  // `--info-foreground-subtle` follows the page, not the inverted tooltip\n  // surface, so take the opposite end of its palette\n  --tooltip-color-link: var(--color-sky-300);\n\n  max-width: 300px;\n\n  a {\n    color: var(--tooltip-color-link);\n    text-decoration: underline;\n  }\n\n  code, pre {\n    font-family: var(--font-mono, ui-monospace, monospace);\n    padding: 0 2px;\n    background-color: color-mix(in srgb, var(--background) 15%, transparent);\n    border-radius: 2px;\n  }\n\n  .bio-properties-panel-tooltip-content h1 {\n    font-size: inherit;\n    font-weight: bold;\n    margin: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
